


































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Action} from 'vuex-class';
import BaseFilter from '@/components/Filter/BaseFilter';
import {notifyError} from '@/utils/notify-helper';
import {BlacklistGeneralFilter} from "@/store/settings/blacklists/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {InputWings} from "wings-ui-components";

@Component({
  components: {InputWings}
})
export default class BlackListGeneralsFilter extends BaseFilter<BlacklistGeneralFilter> {
  @PropSync('show') is_show!: boolean;
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @Action("getBlackListGenerals") actionGetBlackListGenerals: any;
  @Action("exportBlackListGenerals") actionExport: any;

  defaultFilter(): BlacklistGeneralFilter {
    return {
      blacklistId: undefined,
      msisdn: undefined,
      email: undefined,
      page_number: 1
    };
  }

  created() {
    this.filtered();
    this.scroll();
  }

  get transport() {
    return this.$route.params.channel;
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Contact",
        addititional_info: getTranslatedParams(this.filter)
      };
      const resp = await this.actionGetBlackListGenerals({...this.filter, channel: this.transport});
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    } catch (err) {
      this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  exportGenerals(): void {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "Contact",
      addititional_info: getTranslatedParams({general: this.filter.msisdn})
    };
    this.actionExport({...this.filter, channel: this.transport}).then(()=>{
      this.actionLog(this.logObject);
    }).catch((error: any) => {
      this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(error);
    })
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: BlacklistGeneralFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
